import postPinBodyView from './postPinBodyComponent.html';
import './postPinBodyComponent.css';

export function postPinBodyComponent() {
	return {
		bindings: {
			post: '<',
			maxHeight: '<',
			buttonAction: '@',
		},
		controllerAs: 'vm',
		controller: postPinBodyComponentCtrl,
		template: postPinBodyView,
	};
}

export class postPinBodyComponentCtrl {
	constructor($timeout, $element, modal) {
		'ngInject';
		this.$timeout = $timeout;
		this.$element = $element;
		this.modal = modal;
	}

	$onInit() {
		// Use $timeout to ensure that body text has completely rendered
		this.$timeout(() => {
			this.bodyArea = this.$element[0].firstChild;
			this.expanded = false;
			this.scrollHeight = this.bodyArea.scrollHeight;
		}, 0);
		if (this.post && this.post.highlights && this.post.highlights.length) {
			this.richtext = '<p>' + this.post.highlights.join('</p><p>') + '</p>';
		} else if (this.post) {
			this.richtext = this.post.rich_text_body;
		}
	}

	hasOverflow() {
		return !this.expanded && this.scrollHeight > this.getMaxHeight();
	}

	getMaxHeight() {
		return this.expanded ? 999999 : this.maxHeight + 70;
	}

	viewMore() {
		if (this.buttonAction == 'modal') {
			this.modal.iframe(`/p/${this.post.id}`, {
				heading: 'Post Details',
			});
		} else {
			this.expanded = true;
		}
	}

	viewLess() {
		this.expanded = false;
	}
}
